import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import BssoPermissions from "components/LM/Bsso/Permissions";
import OrphanMSearchForm from "components/LM/SocialMediaProfile/Orphan/OrphanMSearchForm";

function OrphanMSearch({ location }) {
  const history = useHistory();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  const [hasError, setHasError] = useState(false);
  const setErrorMessage = (message) => {
    setError(message);
    setHasError(!!message);
  };

  let query = location.state;
  const onChange = (ev) => {
    const inputValue = ev.target.value.trim();
    if (!inputValue) {
      setErrorMessage("");
      history.replace(window.location.pathname, inputValue);
    }

    const lines = inputValue.split("\n").map(line => line.trim());
    const invalidLines = lines.filter(line => {
      if (!line) return false;
      try {
        new URL(line);
        return false;
      } catch {
        return true;
      }
    });

    if (invalidLines.length > 0) {
      setErrorMessage(`Invalid URLs detected: ${invalidLines.join(", ")}`);
    } else {
      setErrorMessage("");
    }

    history.replace(window.location.pathname, ev.target.value);
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    if (!query) return;
    const urls = cleanQuery(query);
    if (!urls.length) return;

    setProcessing(true);
    history.replace(window.location.pathname, query);
    history.push(window.location.pathname + '/results', { urls });
  };

  const cleanQuery = (query) => {
    return [...new Set(query.split("\n").filter(term => term !== ""))];
  }

  return (
		<BssoPermissions permissions={["social_search"]} behaviour="error">
			<OrphanMSearchForm query={query} processing={processing} onChange={onChange} onSubmit={onSubmit} hasError={hasError} error={error}/>
		</BssoPermissions>
	)
}

export default OrphanMSearch;